// V2 KP Rebuild : cartes de la vitrine. Une pastille met à jour le prix, le média (mode shopify ou theme) et les liens (?variant=).
// Aucune variante inventée : les données viennent des attributs rendus par Liquid à partir des variantes Shopify.
if (!customElements.get('v2-showcase-card')) {
  customElements.define(
    'v2-showcase-card',
    class extends HTMLElement {
      connectedCallback() {
        this.pills = [...this.querySelectorAll('.v2-pill[data-variant-id]')];
        this.price = this.querySelector('[data-v2-price]');
        this.links = [...this.querySelectorAll('[data-v2-link]')];
        this.img = this.querySelector('.v2-card__media img');
        if (this.img) this.imgDefault = { src: this.img.getAttribute('src'), srcset: this.img.getAttribute('srcset') };
        this.pills.forEach((pill) => pill.addEventListener('click', () => this.select(pill)));
      }

      select(pill) {
        const already = pill.getAttribute('aria-pressed') === 'true';
        this.pills.forEach((p) => p.setAttribute('aria-pressed', 'false'));
        const base = this.dataset.url;
        if (already) {
          // second clic : retour à la fiche sans variante imposée
          this.links.forEach((a) => a.setAttribute('href', base));
          if (this.price) this.price.textContent = this.dataset.priceDefault;
          this.setImage(this.imgDefault);
          return;
        }
        pill.setAttribute('aria-pressed', 'true');
        const url = `${base}${base.includes('?') ? '&' : '?'}variant=${pill.dataset.variantId}`;
        this.links.forEach((a) => a.setAttribute('href', url));
        if (this.price && pill.dataset.price) this.price.textContent = pill.dataset.price;
        if (pill.dataset.image) this.setImage({ src: pill.dataset.image, srcset: pill.dataset.srcset || null });
      }

      setImage(d) {
        if (!this.img || !d || !d.src) return;
        if (d.srcset) this.img.setAttribute('srcset', d.srcset);
        else this.img.removeAttribute('srcset');
        this.img.src = d.src;
      }
    }
  );
}
